import { useEffect, useState } from "react";
import { X, History } from "lucide-react";
import api from "@/lib/api";

const ACTION_LABEL = { create: "Utworzenie", update: "Aktualizacja", delete: "Usunięcie", import: "Import" };
const ACTION_COLOR = { create: "text-green-400", update: "text-cyan-400", delete: "text-red-400", import: "text-yellow-400" };

export default function LogsPanel({ onClose }) {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/logs").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="absolute inset-0 bg-slate-900 flex flex-col" data-testid="logs-panel">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700">
        <div className="flex items-center gap-2"><History size={18} className="text-cyan-400" /><h2 className="font-heading font-bold text-base">Historia zmian</h2></div>
        <button onClick={onClose} data-testid="logs-close" className="text-slate-400 hover:text-white"><X size={18} /></button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {logs.length === 0 && <div className="text-center text-slate-500 text-sm py-8">Brak zdarzeń</div>}
        {logs.map((l) => (
          <div key={l.id} className="border-b border-slate-800 px-4 py-2.5">
            <div className="flex items-center gap-2 text-sm">
              <span className={`text-xs font-semibold uppercase ${ACTION_COLOR[l.action] || "text-slate-400"}`}>{ACTION_LABEL[l.action] || l.action}</span>
              <span className="text-slate-300">{l.entity_type}</span>
            </div>
            <div className="text-xs text-slate-400 mt-0.5">{l.details}</div>
            <div className="text-[11px] text-slate-500 mt-0.5 font-mono">{l.user_name} · {new Date(l.timestamp).toLocaleString("pl-PL")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
